import { get } from './client'

export interface TaskEntry {
  id: number
  user_id: number
  platform?: string
  task_id?: string
  action?: string
  status?: string
  progress?: string
  submit_time?: number
  start_time?: number
  finish_time?: number
  channel_id?: number
  /** 后端 `data` 可能为 JSON 对象或字符串 */
  data?: string | Record<string, unknown>
  fail_reason?: string
  result_url?: string
  username?: string
}

export interface TaskListResponse {
  items: TaskEntry[]
  total: number
  page: number
  page_size: number
}

/** 与 new-api `GetAllTask` / `GetUserTask` 查询参数一致 */
export interface TaskListQueryParams {
  p?: number
  page_size?: number
  platform?: string
  task_id?: string
  status?: string
  action?: string
  start_timestamp?: number
  end_timestamp?: number
  channel_id?: string
}

export async function getAllTasksApi(params?: TaskListQueryParams): Promise<TaskListResponse> {
  return get<TaskListResponse>('/api/task/', params)
}

export async function getSelfTasksApi(params?: TaskListQueryParams): Promise<TaskListResponse> {
  return get<TaskListResponse>('/api/task/self', params)
}
